import { snacks } from '@features/snackbar/store/snacks';

import { cropMsg } from '../libs';
import { PurchaseState, type PurchaseModel } from '../types';

export const defaultData: PurchaseModel = {
  state: 'default',
};

export const handlePurchaseSuccess = () => {
  snacks.push({
    type: 'success',
    message: 'Congratulations! You have successfully purchased the Digital Original.',
  });
};

export const handlePurchaseError = (msg: string = 'Something went wrong. Please try again or contact support.') => {
  snacks.push({
    type: 'error',
    message: cropMsg(msg),
  });
};

export const texts: Record<PurchaseState, string> = {
  [PurchaseState.ConnectWallet]: 'Connecting your wallet',
  [PurchaseState.SwitchChain]: 'Switching chain',
  [PurchaseState.Error]: 'Try again',
  [PurchaseState.Approval]: 'Waiting for approval',
  [PurchaseState.Pending]: 'Waiting for transaction',
  [PurchaseState.InProgress]: 'Transaction in Progress',
  [PurchaseState.Success]: 'Waiting for data update',
  [PurchaseState.Default]: 'Purchase',
  [PurchaseState.InsufficientFunds]: 'Purchase',
};

export const PURCHASE_UPDATE_INTERVAL_MS = 4000;
